/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import workImg from "../assets/images/work.png";
import axios from "axios";
import { useTokenInfoStats } from "../hooks/useTokenInfo";
import { formatDateWithZone, trimAddress } from "../helper/functions";
import { DEFAULT_CHAIN, afterDate, api_key, contract, dateFormat, networkQuery, transactionQuery } from "../helper/constant";
import { useSidebar } from "../context/useSidebar";

export default function RIghtSidebar() {
  const stats = useTokenInfoStats(1);
  const { isRightSidebarOpen } = useSidebar(0);

  const [fear, setFear] = useState(0);
  const [dexData, setDexData] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const count = useRef(0);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    async function fetch() {
      const response = await axios.get("https://api.coin-stats.com/v2/fear-greed");
      if (response && response.data && response.data.now) {
        setFear(parseInt(response.data.now.value) * 10);
      }
    }

    if (count.current === 0) {
      count.current = 1;
      fetch();
    }
  }, []);

  useEffect(() => {
    const variables = {
      limit: 5,
      offset: 0,
      network: networkQuery,
      token: contract[DEFAULT_CHAIN].BARC_ADDRESS,
      after: afterDate,
      dateFormat: dateFormat,
    };

    try {
      var config = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": api_key,
        },
        body: JSON.stringify({
          query: transactionQuery,
          variables: variables,
        }),
      };

      fetch("https://graphql.bitquery.io", config)
        .then((response) => response.json())
        .then((response) => {
          if (response.data) {
            setDexData(response.data.ethereum.dexTrades);
          } else {
            console.log(response);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (err) {
      console.log(err.message);
    }
  }, []);

  return (
    <>
      <div className=" wallet-bar wow fadeInRight dlab-scroll active bg-primary-gradient" style={{ marginTop: screenWidth > 1700 ? "" : "5rem", right: isRightSidebarOpen ? "0" : "-26.5rem" }} id="wallet-bar" data-wow-delay="0.7s">
        <div className="row  bg-primary-gradient">
          <div className="col-xl-12">
            <div className="card bg-transparent contacts mb-1">
              <div className="card-header border-0 pb-0 px-3 pt-0">
                <div className="mt-2">
                  <h5 className="mb-0">Crypto Fear and Greed Indicator</h5>
                </div>
              </div>
              <div className="text-center pt-2" id="RecentActivityContent">
                {fear && (
                  <ReactSpeedometer
                    needleHeightRatio={0.7}
                    height={200}
                    value={fear}
                    customSegmentStops={[0, 250, 500, 750, 1000]}
                    segmentColors={["#f02836", "#f07d29", "#9aca82", "#35b348"]}
                    currentValueText={`Now: ${fear / 10} Greed`}
                    customSegmentLabels={[
                      {
                        text: 0,
                        position: "INSIDE",
                        color: "#d8dee9",
                      },
                      {
                        position: "OUTSIDE",
                        color: "#d8dee9",
                      },
                      {
                        position: "OUTSIDE",
                        color: "#d8dee9",
                      },
                      {
                        position: "OUTSIDE",
                        color: "#d8dee9",
                      },
                    ]}
                    ringWidth={47}
                    needleTransitionDuration={3333}
                    needleTransition="easeElastic"
                    needleColor={"#a7ff83"}
                    textColor={"#888888"}
                  />
                )}
              </div>
            </div>
          </div>
          <hr></hr>

          <div className="col-xl-12">
            <div className="card Upgrade">
              <div className="card-header border-0 pb-0 px-3 pt-0">
                <div>
                  <h5 className="mb-0">PROJECT LAUNCH</h5>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <img src={workImg} alt="workimg" height="150px" />

                <div className="upgread-stroage">
                  <p className="mb-0">Project launched on</p>
                  <p className="mb-0">483 days</p>
                  <p>30 Tuesday , Aug 2022</p>
                </div>
              </div>
            </div>
          </div>

          <hr></hr>

          <div className="col-xl-12">
            <div className="card progressbar bg-transparent">
              <div className="card-header border-0 p-3 pb-0">
                <div>
                  <h5 className="mb-0">RECENT TRANSACTIONS</h5>
                </div>
              </div>
              <div className="p-0">
                {(dexData ?? [])?.map((rowdata, index) => {
                  return (
                    <div className="quick-info ">
                      <div className="quick-content">
                        <div className="user-name">
                          <p className="mb-0">
                            <a target="_balnk" href={`https://etherscan.io/tx/${rowdata.transaction.hash ? rowdata.transaction.hash : ""}`}>
                              {trimAddress(rowdata.transaction.hash ? rowdata.transaction.hash : "")}
                            </a>
                          </p>
                          <h6 className="mb-0">{rowdata.buyCurrency.symbol ? (rowdata.buyCurrency.symbol === "FIND" ? parseFloat(rowdata.buyAmount).toFixed(3) : parseFloat(rowdata.sellAmount).toFixed(3)) : "-"} FIND</h6>
                        </div>
                      </div>
                      <div className="count">
                        <p className="mb-0">
                          $
                          {stats &&
                            stats.barc_price &&
                            (rowdata.buyCurrency.symbol ? (rowdata.buyCurrency.symbol === "FIND" ? parseFloat(rowdata.buyAmount * stats.barc_price).toFixed(3) : parseFloat(rowdata.sellAmount * stats.barc_price).toFixed(3)) : "-")}
                          {rowdata.buyCurrency.symbol ? rowdata.buyCurrency.symbol === "FIND" ? <i className="fas fa-level-down-alt ms-2 text-danger m-l-10"></i> : <i className="fas fa-level-up-alt ms-2 text-success m-l-10"></i> : "-"}
                        </p>
                        <span>{rowdata.block.timestamp.time ? formatDateWithZone(rowdata.block.timestamp.time) : " - "}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wallet-bar-close"></div>
    </>
  );
}
